import Footer from '../shared/Footer'
import Nav from '../shared/Nav'

const Combine = ({children}) => {
  return (
    <div className='min-h-screen'>
      <Nav/>
      <div className='h-28'></div>
      {children}
      <Footer/>
    </div>
  )
}

export default Combine
